import { Group, Image, NullLogo, Text } from "@repo/ui/core";
import { useCustomer } from "@contexts/CustomerContext";

type Props = {
  size?: "sm" | "md" | "lg" | "xl";
};

const ASPECT = 300 / 236;

const sizeConfig = {
  sm: { h: 22, gap: 8, separator: "16px" },
  md: { h: 40, gap: 16, separator: "24px" },
  lg: { h: 64, gap: 24, separator: "36px" },
  xl: { h: 128, gap: 48, separator: "60px" },
};

export function CombinedLogo({ size = "md" }: Props) {
  const customer = useCustomer();
  const cfg = sizeConfig[size];
  const nullW = Math.round(cfg.h * ASPECT);

  return (
    <Group gap={cfg.gap} align="center" wrap="nowrap">
      <NullLogo compact w={nullW} />
      <Text size={cfg.separator} c="dimmed" fw={300}>
        ×
      </Text>
      <Image
        src={customer.logos.customer}
        alt={customer.name}
        h={cfg.h}
        w="auto"
        fit="contain"
      />
    </Group>
  );
}
